module.exports = __webpack_public_path__ + "img/f4.a7c3ce5b.png";